namespace $ {
	export let $mol_mem_cached = $mol_wire_probe
}
